(function () {
  'use strict';

  var allowedEvents = new Set([
    'hk_page_view',
    'hk_locator_start',
    'hk_locator_search',
    'hk_locator_no_results',
    'hk_location_view',
    'hk_directions_click',
    'hk_phone_click',
    'hk_location_website_click',
    'hk_infinity_contact_click',
    'hk_language_change',
    'hk_research_view',
    'hk_qr_landing',
    'hk_customer_message_start'
  ]);
  var allowedProperties = new Set([
    'location_id',
    'provider_type',
    'district',
    'result_count',
    'language',
    'campaign',
    'source',
    'medium',
    'qr_campaign_id'
  ]);
  var queue = [];
  var pageViewSent = false;

  function analyticsAllowed() {
    try {
      return Boolean(
        window.Shopify &&
        window.Shopify.customerPrivacy &&
        window.Shopify.customerPrivacy.analyticsProcessingAllowed()
      );
    } catch (error) {
      return false;
    }
  }

  function sanitizeValue(value) {
    if (typeof value === 'number') return Number.isFinite(value) ? value : undefined;
    if (typeof value !== 'string') return undefined;
    return value.replace(/[^a-zA-Z0-9 _.-]/g, '').slice(0, 100);
  }

  function sanitizeProperties(properties) {
    var safe = {};
    Object.keys(properties || {}).forEach(function (key) {
      if (!allowedProperties.has(key)) return;
      var value = sanitizeValue(properties[key]);
      if (value !== undefined && value !== '') safe[key] = value;
    });
    return safe;
  }

  function deliver(eventName, properties) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, sanitizeProperties(properties)));
  }

  function track(eventName, properties) {
    if (!allowedEvents.has(eventName)) return false;
    var payload = { eventName: eventName, properties: sanitizeProperties(properties || {}) };
    if (!analyticsAllowed()) {
      queue.push(payload);
      return false;
    }
    deliver(payload.eventName, payload.properties);
    return true;
  }

  function flush() {
    if (!analyticsAllowed()) return;
    while (queue.length) {
      var payload = queue.shift();
      deliver(payload.eventName, payload.properties);
    }
  }

  function safeCampaignValue(params, key) {
    return sanitizeValue(params.get(key) || '');
  }

  function boot() {
    if (!document.querySelector('[data-hk-page]') && !document.querySelector('[data-hk-availability-only="true"]')) return;

    var params = new URLSearchParams(window.location.search);
    var language = document.documentElement.lang || 'en';

    if (!pageViewSent) {
      pageViewSent = true;
      track('hk_page_view', {
        language: language,
        campaign: safeCampaignValue(params, 'utm_campaign'),
        source: safeCampaignValue(params, 'utm_source'),
        medium: safeCampaignValue(params, 'utm_medium')
      });
    }

    var qrCampaignId = safeCampaignValue(params, 'qr_campaign');
    if (qrCampaignId) {
      track('hk_qr_landing', {
        language: language,
        qr_campaign_id: qrCampaignId,
        campaign: safeCampaignValue(params, 'utm_campaign'),
        source: safeCampaignValue(params, 'utm_source'),
        medium: safeCampaignValue(params, 'utm_medium')
      });
    }

    document.querySelectorAll('[data-hk-event]').forEach(function (element) {
      element.addEventListener('click', function () {
        track(element.getAttribute('data-hk-event'));
      });
    });

    document.querySelectorAll('form[action*="localization"]').forEach(function (form) {
      form.addEventListener('submit', function () {
        var language = form.querySelector('[name="language_code"]');
        if (language) track('hk_language_change', { language: language.value });
      });
    });
  }

  window.HaroHKAnalytics = Object.freeze({ track: track, flush: flush });
  document.addEventListener('visitorConsentCollected', flush);
  document.addEventListener('shopify:customer_privacy:consent_changed', flush);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
